// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Container imports
const ArticleProfileInterestsItem = require('./interests-item')

// BEM Block entity definition
const bem = BemEntity('ArticleProfileInterests')

function ArticleProfileInterests(props) {
  return (
    tag('section', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('header')
      },
        props.isLoading
        ? 'Loading interests...'
        : 'Related interests'
      ),
      props.isLoading
      ? tag('div', { className: bem.element('loading-indicator') })
      : tag('div', {
        className: bem.element('list')
      },
        props.items.map(interest => (
          tag(ArticleProfileInterestsItem, {
            key: interest.key,
            interest,
            onInterestFollowClick: props.onInterestFollowClick,
            onInterestNavigate: props.onInterestNavigate
          })
        ))
      )
    )
  )
}

ArticleProfileInterests.propTypes = {
  // Values
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  // Callbacks
  onInterestFollowClick: PropTypes.func.isRequired,
  onInterestNavigate: PropTypes.func.isRequired
}

module.exports = ArticleProfileInterests
